const WIDGET_SHOULD_INIT_FALLBACK = true;

/**
 * Preact widgets lifecycle with performance tracking and logs
 * @param widget: Object defined in src/js/preact/widgets/[widget-name]/widget.js
 */
export const asyncPreactWidget = (widget) => ({
  isOnPage() {
    return Boolean(
      (widget.htmlId && document.getElementById(widget.htmlId)) ||
        (widget.selector && document.querySelector(widget.selector))
    );
  },
  shouldInit() {
    return widget.shouldInit?.() ?? WIDGET_SHOULD_INIT_FALLBACK;
  },
  start() {
    return performance && performance.mark(`asyncJS-start ${widget.name}`);
  },
  hydrate(chunk) {
    chunk.hydrate();
    performance && performance.mark(`asyncJS-done  ${widget.name}`);
    console.info(`async loaded : ${widget.name}`);
  },
  error(error) {
    console.error(`can not load/init ${widget.name} : `, error);
  },
});
